/**
 * Resolve a localised version of an item text field.
 *
 * When the sync service has added translated variants (e.g. `itemdescription_fr`)
 * and the active language matches, the translated value is returned.
 * Falls back to the English original when no translation is available.
 *
 * @param item   The ItemRow object from IndexedDB
 * @param field  The base field name (e.g. 'itemdescription')
 * @param lang   Active language code ('en' | 'fr' | 'es')
 * @returns      The best available string for the given language, or null/undefined
 */
export function localeField<T extends Record<string, unknown>>(
  item: T,
  field: string,
  lang: string,
): string | null | undefined {
  if (lang !== 'en') {
    const translated = item[`${field}_${lang}`] as string | null | undefined;
    if (translated) return translated;
  }
  return item[field] as string | null | undefined;
}
